/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Scan_RequiredInputs */



/**
* | output |
* | --- |
* | "Select both files and click \"Scan tracks\" to detect their track layout." |
*
* @param {Audio_Embed_Export_Scan_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_scan_required = /** @type {((inputs?: Audio_Embed_Export_Scan_RequiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Scan_RequiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez les deux fichiers et cliquez sur « Analyser les pistes » pour détecter leur disposition.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie beide Dateien aus und klicken Sie auf „Spuren scannen“, um deren Spurlayout zu erkennen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona entrambi i file e fai clic su \"Scansiona tracce\" per rilevare la loro struttura.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите оба файла и нажмите «Сканировать дорожки», чтобы определить их расположение.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione ambos archivos y haga clic en \"Escanear pistas\" para detectar su trazado.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择这两个文件，然后点击“扫描音轨”来检测它们的音轨布局。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("両方のファイルを選択し、「トラックをスキャン」をクリックしてトラックレイアウトを検出します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("दोनों फाइलों का चयन करें और उनके ट्रैक लेआउट का पता लगाने के लिए \"स्कैन ट्रैक्स\" पर क्लिक करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione ambos os arquivos e clique em \"Escanear faixas\" para detectar o layout das faixas.")
	return /** @type {LocalizedString} */ ("Select both files and click \"Scan tracks\" to detect their track layout.")
});